import { Component, OnInit, Input } from '@angular/core';

import { Partition } from '@classes/simulation/partition';
import { KpiByYear } from '@classes/simulation/kpi-by-year';

@Component({
  selector: 'app-datatable-summary',
  templateUrl: './datatable-summary.component.html',
  styleUrls: ['./datatable-summary.component.scss']
})
export class DatatableSummaryComponent implements OnInit {
    @Input() partitions: Partition[];
    @Input() kpisByYear: KpiByYear[];

    constructor() { }

    ngOnInit() {
    }
}
